import { TicketCombinationDto, TicketCombinationQuery, TicketCombinationService } from '@/api';
import { getQueryParams } from '@/utils/api';

export default {
  getTicketCombinationList: async (query: TicketCombinationQuery): Promise<TicketCombinationDto[]> => {
    const response = await TicketCombinationService.ticketCombinationControllerGetAll(getQueryParams(query));
    return response.data;
  },
};
